<template>
  <div>
    <Header />
    <v-row>
      <v-col cols="12">
        <div
          class="mx-auto text-center"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          POLÍTICA DE PRIVACIDAD
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          USO DE LA APLICACION
        </div>
      </v-col>
      <v-col cols="12">
        <p class="mx-5 text-justify">
          AL UTILIZAR ESTA APLICACION, ACEPTA QUE LEYÓ, ENTENDIÓ, ACEPTÓ Y ESTÁ
          DE ACUERDO CON ESTOS TÉRMINOS Y CONDICIONES. SI NO ESTÁ DE ACUERDO O
          NO CUMPLE CON LOS TÉRMINOS DE USO DEL SERVICIO Y DESEA DEJAR DE USAR
          EL SERVICIO, NO SIGA UTILIZANDO ESTA APLICACIÓN.
        </p>
      </v-col>
      <v-col cols="12">
        <p class="mx-5 text-justify">
          Asistencia Regional se reserva el derecho de modificar, variar y
          cambiar los Términos de Uso o sus políticas relacionadas con el
          Servicio en cualquier momento que considere oportuno. Dichas
          modificaciones, variaciones o cambios en los Términos de uso o sus
          políticas relacionadas con el Servicio entrarán en vigor después de la
          publicación de una versión actualizada en la Aplicación. Usted acepta
          que es su responsabilidad revisar los Términos de Uso de manera
          regular.
        </p>
        <p class="mx-5 text-justify">
          Al utilizar el Servicio, declara y garantiza expresamente que tiene
          derecho legal a aceptar y estar de acuerdo con los Términos de uso. Al
          utilizar el Servicio, usted además declara y garantiza que tiene el
          derecho, la autoridad y la capacidad para usar el Servicio y de
          cumplir con los Términos de Uso. Además, confirma que toda la
          información que proporcione será verdadera y precisa. Su uso del
          Servicio es para su uso personal y exclusivo. Usted se compromete a no
          autorizar a otros a usar su identidad o estado de usuario, y no puede
          ceder ni transferir su cuenta de usuario a ninguna otra persona o
          entidad. Al utilizar el Servicio, usted se compromete a cumplir con
          todas las leyes aplicables, ya sea en su país de origen o en el país,
          estado y ciudad en los que se encuentre mientras utiliza el Servicio.
        </p>
        <p class="mx-5 text-justify">
          Es requisito necesario para la adquisición de los productos que se
          ofrecen en este aplicación movil, que lea y acepte los siguientes
          Términos y Condiciones que a continuación se redactan. El uso de
          nuestros servicios implicará que usted ha leído y aceptado los
          Términos y Condiciones de Uso en el presente documento. Para adquirir
          servicios de asistencia, será necesario el registro por parte del
          usuario, con ingreso de datos personales fidedignos.
        </p>
      </v-col>
      <v-col cols="12">
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          PRIVACIDAD
        </div>
      </v-col>
      <p class="mx-5 text-justify">
        SOS REGIONAL garantiza que la información personal que usted envía
        cuenta con la seguridad necesaria. Los datos ingresados por usuario o en
        el caso de requerir una validación de los pedidos no serán entregados a
        terceros, salvo que deba ser revelada en cumplimiento a una orden
        judicial o requerimientos legales.
      </p>
      <v-col cols="12">
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          Información que recogemos cuando utilizas nuestros servicios:
        </div>
      </v-col>
      <p class="mx-5 text-justify">
        Recogemos información sobre tu actividad en los Servicios de SOS
        Regional, que utilizamos para prestarte dichos Servicios y
        proporcionarte funciones que nos permiten personalizar tu experiencia.
        Esto incluye, por ejemplo, ofrecerte la mejor ruta y destinos y los
        viajes. A continuación, te indicamos la información que podemos recoger
        sobre tu actividad
      </p>
      <p class="mx-5 text-justify">
        Información detallada de ubicación, trayecto y ruta. La información de
        ubicación y ruta se recoge, por ejemplo, en forma de señales googleapis
        y otros datos que envía el dispositivo móvil en el que has descargado y
        activado la Aplicación. Esta información se guarda en un historial de
        rutas. Los tipos de datos de ubicación que se recogen dependen en parte
        de los ajustes de tu dispositivo y de la configuración de tu Cuenta. Por
        ejemplo, en función de los ajustes que hayas seleccionado en el
        dispositivo o de la configuración de tu Cuenta, SOS Regional puede
        recoger (o no) información sobre tu ubicación y tus trayectos, incluso
        cuando no utilizas la Aplicación.;
      </p>
      <v-col cols="12">
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          Por qué recoge SOS Regional estos datos
        </div>
      </v-col>
      <p class="mx-5 text-justify">
        Podemos utilizar la información personal que recogemos o que nos
        proporcionas con las siguientes finalidades:
      </p>
      <ul class="mx-5 text-justify">
        <li>
          Utilizamos tus datos de ubicación y ruta o tu historial para ofrecerte
          servicios de navegación, las mejores rutas, y otros sitios .
        </li>
        <li>
          Compartimos la información que nos envías con otros usuarios de los
          Servicios y te ayudamos a comunicarte con SOS Regional y con otros
          usuarios.
        </li>
      </ul>
      <v-col cols="12">
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          Compartir tu información
        </div>
      </v-col>
      <p class="mx-5 text-justify">
        Los Servicios se basan en usuarios que comparten información
        públicamente con SOS Regional y con otros miembros de dicha comunidad.
        Puedes compartir información personal, como el nombre, su vehiculo, la
        foto, los datos de ubicación, los informes y otros datos. Esta
        información puede compartirse directamente con los Servicios y con todos
        los usuarios que interactúen con los Servicios si así lo defines en la
        configuración.
      </p>
      <p class="mx-5 text-justify">
        Puedes decidir si quieres subir contenido a los Servicios. No obstante,
        el contenido que compartas y envíes no será privado ni confidencial, y
        es posible que se publique y se difunda. La información que subas se
        publicará junto con tu nombre de usuario y otros datos, como la
        información personal que hayas añadido a tu perfil de usuario público.
      </p>
      <v-col cols="12">
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          Cómo usa SOS Regional la información agregada
        </div>
      </v-col>
      <p class="mx-5 text-justify">
        SOS Regional puede usar información agregada (incluidos datos de
        ubicación anónimos), para prestar los Servicios correctamente, mejorar
        su calidad, optimizar tu experiencia, crear servicios y funciones
        (incluidos servicios personalizados), modificar o cancelar contenido o
        servicios, y para otras finalidades internas.
      </p>
      <v-col cols="12">
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          Privacidad del usuario
        </div>
      </v-col>
      <p class="mx-5 text-justify">
        En SOS Regional recogemos la ubicación de tu dispositivio en segundo
        plano, para brindarte mediante notificaciones, trayectos de movimiento
        en tiempo real del proveedor quee tengas cerca de tu posición. Dicho
        proveedor tiene la opción de dejar de usar la ubicación en segundo plano
        una vez es terminada la asistencia del cliente y borrar todo registro de
        ubicación.
      </p>
      <v-col cols="12">
        <div
          class="mx-5"
          :class="[
            $vuetify.breakpoint.mdAndUp ? 'fontTitulo' : 'fontTituloResponsive',
          ]"
        >
          Bases jurídicas para el tratamiento de tus datos
        </div>
      </v-col>
      <p class="mx-5 text-justify">
        En SOS Regional sólo recogemos y tratamos datos personales cuando
      </p>
      <v-col class="mx-5 text-justify" cols="12">
        <ul>
          <li>Tenemos tu consentimiento</li>
          <li>
            Cuando es necesario para prestarte nuestros servicios en base al
            cumplimiento de nuestros contratos
          </li>
          <li>En caso que debamos cumplir con nuestras obligaciones legales</li>
        </ul>
      </v-col>
      <p class="mx-5 my-5 text-justify">
        SOS Regional se reserva el derecho de modificar en cualquier momento su
        política de privacidad. En cualquier caso, SOS Regional siempre refleja todos
        los cambios de forma transparente y visible en esta política de
        privacidad.
      </p>
    </v-row>
  </div>
</template>
<script>
import Header from "./Header.vue";
export default {
  name: "TerminosCondiciones",
  components: {
    Header,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");
.fontTitulo {
  font-family: "Zilla Slab", serif;
  font-size: 35px;
}
.fontTituloResponsive {
  font-family: "Zilla Slab", serif;
  font-size: 20px;
}
</style>